export default {
    props: {
        dataMenuHeading: {
            type: String,
        },

        dataMenuWidth: {
            type: String,
            default: '240px'
        },

        dataMenuHeight: {
            type: String,
            default: 'auto'
        },

        dataMenuPadding: {
            type: String
        },
    },

    computed: {
        menuHeading() {
            return this.dataMenuHeading
        },

        menuWidth() {
            return this.dataMenuWidth
        },

        menuHeight() {
            return this.dataMenuHeight
        },

        menuPadding() {
            return this.dataMenuPadding
        },
    }
}
